/* unplugin-vue-components disabled */import { render } from "./PrivacyPolicy.vue?vue&type=template&id=ed674ccc"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__